import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { ApiService } from '../../../services/api/api.service';
import { mergeMap } from 'rxjs/operators';
import { UpdateEnclosureCardAction } from '../../actions/enclosure-cards/update-enclosure-card-action';
import { UpdateEnclosureCardErrorAction } from '../../actions/enclosure-cards/update-enclosure-card-error-action';
import { GetEnclosureCardAction } from '../../actions/enclosure-cards/get-enclosure-card-action';

@Injectable()
export class UpdateEnclosureCardEffect {
  constructor(private api: ApiService, private actions: Actions) {
  }


  public UpdateEnclosureCard = createEffect(() => this.actions
    .pipe(
      ofType(UpdateEnclosureCardAction.type),
      mergeMap(action => {
        const updateEnclosureCardAction = <UpdateEnclosureCardAction>action;
        return this.api.updateEnclosureCard(updateEnclosureCardAction.enclosureCard).then(() => {
          return new GetEnclosureCardAction(updateEnclosureCardAction.group);
        }, error => {
          return new UpdateEnclosureCardErrorAction(error);
        });
      })
    ));
}
